import { jsx as _jsx } from "react/jsx-runtime";
import { MapWithTrack } from 'widgets/map.tracking/ui';
import { useLoadMapTrack } from 'console/shared/hooks/vehicle';
import { memo } from 'react';
import { useAppSelector } from 'shared/hooks/redux/hooks';
import { LegacyDevice } from 'console/device/device';
import { DevicePermission } from 'console/device/device_ts';
import { selectDevice } from 'entities/device/lib';
export const DashboardVehicleMap = memo(function VehicleMap(props) {
    const { device_id } = props;
    useLoadMapTrack(device_id);
    const history_available = useAppSelector((state) => {
        const device = selectDevice(state, device_id);
        if (!device) {
            return false;
        }
        return LegacyDevice.has_access(state.account.id, device, [
            DevicePermission.view_gps,
        ]);
    });
    return (_jsx(MapWithTrack, { device_id: device_id, show_geozones_buttons: false, show_download_track: false, show_search: false, show_settings: false, show_track: history_available }));
});
